module.exports = __webpack_public_path__ + "img/1.1590189b.png";